import { render } from "./ControleDeUsuarios.vue?vue&type=template&id=7677635f"
import script from "./ControleDeUsuarios.vue?vue&type=script&lang=js"
export * from "./ControleDeUsuarios.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__